import { createFileRoute } from '@tanstack/react-router'

import { HealthInsurancePage } from '../../../../components/pages/health-insurance/health-insurance-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/health-insurance/')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <HealthInsurancePage />
    </PermissionChecker>
  ),
})
